import {
  MET_PUR_SUMMARY_ITEM,
  MET_PUR_EVOLUTION_ITEM,
  MET_PUR_FILTERS_ITEM,
  MET_PUR_PROVIDERS_ITEM,
} from './met-pur-items.js'

/** @type {import('../help-index.js').HelpScreen} */
export const MET_PUR_HELP = {
  screenId: 'met-pur',
  label: 'Compras',
  navPath: 'Métricas → Compras',
  keywords: ['reporte compras', 'proveedores', 'evolución compras'].map((k) => k.toLowerCase()),
  status: 'draft',
  summary: 'Indicadores de compras: resumen, evolución, filtros y ranking de proveedores.',
  sidebarItems: [MET_PUR_SUMMARY_ITEM, MET_PUR_EVOLUTION_ITEM, MET_PUR_FILTERS_ITEM, MET_PUR_PROVIDERS_ITEM],
}
